module.exports = __webpack_public_path__ + "static/assets/0498579ca9613f17e0081b09a098ce51.svg";